module.exports = __webpack_public_path__ + "static/media/beech.6e78ca44.jpg";